/**
 * DEPRECATED:
 * Not used for subsidy anymore, but may useful for other pages.
 *
 * Append current class to specific target.
 *
 * How it works:
 * 1. Checks for element on data-name, data-scope and data-fallback.
 * 2. Adds `*--current` if data-name and data-scope matched queryvars.
 * 3. Or, also adds `*--current` if data-fallback is specified.
 */
function appendCurrent($, klass) {

  const querystrings = window.location.search.substring(1).split('&');

  // Notice the comma prefix, this only works for classes, not id.
  const targets = $(`.${ klass }`);

  // Also the current indicator is hard coded with BEM modifier.
  const klassname = `${ klass }--current`;

  let isAppended = false;

  $.each(targets, (idx, elem) => {

    const name = $(elem).data('name');
    const scope = $(elem).data('scope');

    $.each(querystrings, (_, query) => {

      // Split query into key-value pair.
      const pairs = query.split('=');

      let isMatched = false;

      if(name === pairs[0] && scope === pairs[1]) {
        $(elem).addClass(klassname);
        isAppended = true;
      }
    });
  });

  // When the matchers still didn't append, check for fallback.
  if(!isAppended) {
    $.each(targets, (idx, elem) => {

      const isFallback = $(elem).data('fallback');

      if(isFallback) {
        $(elem).addClass(klassname);
      }
    });
  }
}

/**
 * Returns key-value pair of querystrings.
 */
function getQueries() {
  let vars = [], hash;
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

  for(let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }

  return vars;
}

/**
 * Navigate user to selected prefecture.
 */
function prefectureSelect($) {

  const target = $('select[name="js-subsidy-prefecture"]');

  // Determine current page by checking querystring.
  const q = getQueries();

  let isCalendarYearly = false;
  let isCalendarMonthly = false;

  let basepath = '/subsidy/?';

  if(q.calendar) {
    if(q['calendar-type'] === 'monthly') {
      isCalendarMonthly = true;
      basepath += '?calendar=calendar&calendar-type=monthly';
    }

    if(q['calendar-type'] === 'yearly') {
      isCalendarYearly = true;
      basepath += '?calendar=calendar&calendar-type=yearly';
    }
  }

  target.change(() => {
    const scope = target.find('option:selected').data('scope');

    window.location = `${basepath}&subsidy_prefecture=${scope}`;
  });
}

/**
 * Runner script.
 */
function run($) {
  prefectureSelect($);
}

module.exports = {
  run: run
};
